export const uploadStatusEnum = {
  STOPPED: "stopped",
  SENDING: "sending",
  COMPLETED: "completed",
};
